import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../has.js";
import { getOwnClassMetadata as e } from "../metadata.js";
import { trackAccess as t } from "../tracking.js";
import { processPrototypePropertyMetadata as r } from "../extensions/serializableProperty.js";
var o = new Set(),
    s = new Set();

function i(t) {
  return function (r) {
    r.prototype.declaredClass = t, a(r);
    var i = [],
        n = [];
    var c = r.prototype;

    for (; c;) {
      c.hasOwnProperty("initialize") && !o.has(c.initialize) && (o.add(c.initialize), i.push(c.initialize)), c.hasOwnProperty("destroy") && !s.has(c.destroy) && (s.add(c.destroy), n.push(c.destroy)), c = Object.getPrototypeOf(c);
    }

    o.clear(), s.clear();

    var l = /*#__PURE__*/function (_r) {
      _inherits(l, _r);

      var _super = _createSuper(l);

      function l() {
        var _this;

        _classCallCheck(this, l);

        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }

        if (_this = _super.call.apply(_super, [this].concat(e)), _this.constructor === l && "function" == typeof _this.postscript) {
          var _this2;

          if (i.length && Object.defineProperty(_assertThisInitialized(_this), "initialize", {
            enumerable: !1,
            configurable: !0,
            value: function value() {
              for (var _e = i.length - 1; _e >= 0; _e--) {
                i[_e].call(this);
              }
            }
          }), n.length) {
            var _e2 = !1;

            Object.defineProperty(_assertThisInitialized(_this), "destroy", {
              enumerable: !1,
              configurable: !0,
              value: function value() {
                if (!_e2) {
                  _e2 = !0;

                  for (var _e3 = 0; _e3 < n.length; _e3++) {
                    n[_e3].call(this);
                  }
                }
              }
            });
          }

          (_this2 = _this).postscript.apply(_this2, e);
        }

        return _possibleConstructorReturn(_this);
      }

      return l;
    }(r);

    return l.__accessorMetadata__ = e(r.prototype), l.prototype.declaredClass = t, l;
  };
}

function n(e, r) {
  return null == r.get ? function () {
    var r = this.__accessor__.properties.get(e);

    if (void 0 === r) return;
    t(r);
    var o = this.__accessor__.store;
    return o.has(e) ? o.get(e) : r.metadata.value;
  } : function () {
    var t = this.__accessor__.properties.get(e);

    if (void 0 !== t) return t.getComputed();
  };
}

function a(t) {
  var o = t.prototype,
      s = e(o).properties,
      i = {};

  var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(s)),
      _step;

  try {
    var _loop = function _loop() {
      var e = _step.value;
      var t = s[e];
      r(t), i[e] = {
        enumerable: !0,
        configurable: !0,
        get: n(e, t),
        set: function set(r) {
          var o = this.__accessor__;

          if (void 0 !== o) {
            if (!Object.isFrozen(this)) {
              if (o.initialized && t.readOnly) throw new TypeError("[accessor] cannot assign to read-only property '".concat(e, "' of ").concat(this.declaredClass));
              if (2 === o.lifecycle && t.constructOnly) throw new TypeError("[accessor] cannot assign to construct-only property '".concat(e, "' of ").concat(this.declaredClass));
              o.set(e, r);
            }
          } else Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          });
        }
      };
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  Object.defineProperties(t.prototype, i);
}

export { a as finalizeClass, i as subclass };